export enum SignDocumentTypes {
  FACTORING = 'factoring',
  CONFIRMING = 'confirming',
  DECLARACION_JURADA = 'declaracion jurada',
}
